import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IEventAssignment } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class EventAssignmentService extends BaseService<IEventAssignment> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'eventAssignment');
  }
}

export { IEventAssignment } from '../shared/api';
